function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// DEPRECATED COMPONENT, DO NOT USE. PLEASE USE APP-COMPONENTS CompactPhoneNumbers INSTEAD.
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button, Icon } from '@unite-us/ui';
import phones from "../../utils/phones";
var MAX_NUMBERS_COLLAPSED = 3;
var Caret = /*#__PURE__*/React.createElement(Icon, {
  icon: "IconChevronDown",
  style: {
    svg: {
      display: 'inline-block',
      verticalAlign: 'bottom'
    }
  }
});

/**
 * @visibleName CompactPhoneNumbers DEPRECATED
*/
var CompactPhoneNumbers = function CompactPhoneNumbers(_ref) {
  var _ref$phone_numbers = _ref.phone_numbers,
    phone_numbers = _ref$phone_numbers === void 0 ? [] : _ref$phone_numbers;
  if (!phone_numbers.length) {
    return null;
  }
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var rootClasses = classNames('ui-contact-information__compact-phone', {
    expanded: expanded
  });
  var phoneNumbers = phones.sortPhoneNumbers(phone_numbers, ['mobile', 'home', 'work', 'fax', 'unknown']).filter(function (number) {
    return Boolean(number.phone_number);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: rootClasses
  }, /*#__PURE__*/React.createElement("div", {
    className: "ui-provider-card__icon-text--phone"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "IconPhone"
  })), phoneNumbers.map(function (phoneNumber, index) {
    var _phoneNumber$extensio = phoneNumber.extension,
      extension = _phoneNumber$extensio === void 0 ? '' : _phoneNumber$extensio,
      _phoneNumber$phone_ty = phoneNumber.phone_type,
      phone_type = _phoneNumber$phone_ty === void 0 ? '' : _phoneNumber$phone_ty,
      _phoneNumber$phone_nu = phoneNumber.phone_number,
      phone_number = _phoneNumber$phone_nu === void 0 ? '' : _phoneNumber$phone_nu,
      _phoneNumber$is_prima = phoneNumber.is_primary,
      is_primary = _phoneNumber$is_prima === void 0 ? false : _phoneNumber$is_prima;
    if (!expanded && index + 1 > MAX_NUMBERS_COLLAPSED || !phone_number) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "phone-number",
      key: "phone-".concat(phone_number)
    }, phone_type && /*#__PURE__*/React.createElement("span", {
      className: "phone-number__phone-type",
      "data-test-element": "phone-numbers_type_".concat(index)
    }, phone_type, ":", ' '), /*#__PURE__*/React.createElement("a", {
      href: phones.getTelLink(phoneNumber),
      target: "_blank",
      tabIndex: 0,
      rel: "noopener noreferrer",
      "data-test-element": "phone-numbers_link_".concat(index)
    }, /*#__PURE__*/React.createElement("span", {
      "data-test-element": "phone-numbers_number_".concat(index)
    }, "".concat(phones.formatPhoneNumber(phone_number)).concat(extension ? " ".concat(extension) : ''))), is_primary && /*#__PURE__*/React.createElement("span", {
      className: "phone-number__is-primary",
      "data-test-element": "phone-numbers_primary_".concat(index)
    }, ' ', "Primary"));
  }), phoneNumbers.length > MAX_NUMBERS_COLLAPSED && /*#__PURE__*/React.createElement("div", {
    className: "phone-number__toggle",
    "data-test-element": "phone-numbers_toggle"
  }, /*#__PURE__*/React.createElement(Button, {
    iconRight: Caret,
    label: "See ".concat(!expanded ? 'more' : 'less'),
    link: true,
    onClick: function onClick() {
      return setExpanded(!expanded);
    }
  })));
};
CompactPhoneNumbers.propTypes = {
  phone_numbers: PropTypes.arrayOf(PropTypes.shape({
    phone_type: PropTypes.string,
    phone_number: PropTypes.string,
    country_code: PropTypes.string,
    is_primary: PropTypes.bool,
    extension: PropTypes.string
  }))
};
CompactPhoneNumbers.defaultProps = {
  phone_numbers: []
};
export default CompactPhoneNumbers;